<template>
    <span class="diff-number" :class="diffClass">{{ display }}</span>
</template>

<script>
export default {
    props: ['number', 'filter', 'prepend', 'append'],
    computed: {
        diffClass() {
            if (this.number === 0) {
                return 'diff-neutral';
            }

            if (this.number > 0) {
                return 'diff-positive';
            }

            return 'diff-negative';
        },
        display() {
            return `${this.prepend || ''}${this.indicatorValue}${this.append ||
                ''}`;
        },
        indicatorValue() {
            if (this.number > 0) {
                return '+' + this.filteredValue;
            }

            return this.filteredValue;
        },
        filteredValue() {
            if (this.filter) {
                return Vue.filter(this.filter)(this.number);
            }

            return this.number;
        },
    },
};
</script>

